<div class="faq-wrap" *ngIf="faqData!= undefined">
    <div >
      <div class="faq-row">
        <div class="faq-col">
          <h3>Frequently Asked Questions</h3>
        </div>
        <div class="faq-col-right">
          <mat-accordion class="example-headers-align">
            <mat-expansion-panel *ngFor="let item of faqData; first as isFirst" [expanded]="isFirst">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <p>{{item.question?item.question:'Question'}}</p>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="innerHtmlFaq" [innerHtml]="item.answer |safehtml"></div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
  
    </div>
  </div>
  <div [innerHtml]="structuredData"></div>
  